// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/_@kangc_v-md-editor@1.7.12@@kangc/v-md-editor/lib/theme/style/github.css
// module id = 156
// module chunks = 50